
import React from "react";

import {
    Field,
    Button,
    PhotoActions,
    PhotoList,
    PhotoContainer,
    PhotoPreview,
    RemovePhoto,
    Info
} from "./design";

const PhotoPicker = ({
                         label,
                         photos,
                         processing,
                         disabled,
                         onFiles,
                         onCamera,
                         onRemove,
                         onPreview
                     }) => {
    return (
        <Field>
            <label>{label}</label>

            <input
                type="file"
                accept="image/*"
                multiple
                disabled={disabled || processing}
                onChange={e => {
                    onFiles(e.target.files);
                    e.target.value = "";
                }}
            />

            <PhotoActions>
                <Button
                    type="button"
                    $secondary
                    disabled={
                        disabled ||
                        processing ||
                        photos.length >= 12
                    }
                    onClick={onCamera}
                >
                    📷 Kamera öffnen
                </Button>
            </PhotoActions>

            <PhotoList>
                {photos.map((photo, index) => (
                    <PhotoContainer key={photo.preview}>
                        <PhotoPreview
                            src={photo.preview}
                            alt={`Foto ${index + 1}`}
                            onClick={() =>
                                onPreview(photo.preview)
                            }
                        />

                        <RemovePhoto
                            type="button"
                            disabled={disabled || processing}
                            onClick={() => onRemove(index)}
                            title="Foto entfernen"
                        >
                            ×
                        </RemovePhoto>
                    </PhotoContainer>
                ))}
            </PhotoList>

            <Info>
                {photos.length} / 12 Fotos ausgewählt
            </Info>
        </Field>
    );
};

export default PhotoPicker;
